<template>
  <div class="advantage page-container" v-if="!(+notRender)">
    <ul class="advantage__list" v-if="advantages">
      <li class="advantage__item" v-for="(advantage, i) in advantages" :key="i">
        <div
          class="advantage__wrap"
          @mouseenter="visible = i"
          @mouseleave="visible = null">
          <img
            :src="advantage.image"
            loading="lazy"
            data-force-load="true"
            alt="icon"
            style="pointer-events: none"/>
          <span v-html="advantage.text"></span>
          <Tooltip
            v-if="advantage.text"
            class="advantage__tooltip"
            :isUp="i < 2"
            :horizontal-align="i === 0 || i === 2 ? 'left' : 'right'"
            vertical-align="top"
            :html-text="advantage.tooltipHtml"
            :is-visible="visible === i"
            is-arrow/>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import Tooltip from '../helpers/Tooltip'

export default {
  name: 'Advantages',
  components: { Tooltip },
  data () {
    return {
      visible: null
    }
  },
  props: {
    notRender: {
      type: String,
      default: '0'
    }
  },
  computed: {
    advantages () {
      return [
        {
          image: '/img/svgo/product-page/delivery-pl.svg',
          text: this.$t('advantage_delivery'),
          tooltipHtml: this.$t('advantage_tooltip_delivery')
        },
        {
          image: '/img/svgo/product-page/return-pl.svg',
          text: this.$t('advantage_testdrive'),
          tooltipHtml: this.$t('advantage_tooltip_testdrive')
        },
        {
          image: '/img/svgo/product-page/payment-pl.svg',
          text: this.$t('advantage_paypart'),
          tooltipHtml: this.$t('advantage_tooltip_paypart')
        },
        {
          image: '/img/svgo/product-page/support-pl.svg',
          text: this.$t('advantage_services'),
          tooltipHtml: this.$t('advantage_tooltip_services')
        }
      ]
    }
  }
}
</script>

<style scoped lang="sass">

.advantage--footer
  padding-top: 40px

.advantage__list
  +list-unstyled
  display: flex
  flex-flow: row wrap
  position: relative
  width: 100%
  background: $page-bg--mutted
  border-radius: 10px
  padding: 20px

  +mmin($tablet)
    padding: 12px

.advantage__wrap
  width: 100%
  display: flex
  justify-content: center
  flex-direction: column
  align-items: center
  margin: 0 auto
  max-width: max-content
  text-align: center

  +mmin($extsmall--hor)
    flex-direction: row
    min-width: auto
    text-align: left

  span
    font-weight: 500

.advantage__item
  width: 50%
  display: flex
  justify-content: center
  align-items: center
  padding: 20px
  font-size: 14px
  color: #4c4c4c
  position: relative

  +mmax(768)
    &:nth-child(1)
      padding: 0 20px 20px 0

    &:nth-child(2)
      padding: 0 0 20px 20px
      border-left: 1px solid #eaeaea

    &:nth-child(3)
      padding: 20px 20px 0 0
      border-top: 1px solid #eaeaea

    &:nth-child(4)
      padding: 20px 0 0 20px
      border-top: 1px solid #eaeaea
      border-left: 1px solid #eaeaea

  +mmin($tablet)
    width: 25%
    justify-content: center

    &:not(:first-child)
      border-top: none
      border-left: 1px solid #eaeaea

  img
    max-width: 50px
    margin-bottom: 10px

    +mmin($extsmall--hor)
      flex-shrink: 0
      margin-right: 20px
      margin-bottom: 0

</style>
